var _path, _g, _path2, _path3, _ellipse, _g2, _ellipse2, _g3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPositiveRejseklubben = function SvgPositiveRejseklubben(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 230 52"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "positive-rejseklubben_svg__a",
    width: 31,
    height: 22,
    x: 2,
    y: 17,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.664 18.663c-.324.138-1.419.63-1.712.8-4.227 2.369-14.64 14.83-14.655 16.861v.138c.2 1.078 17.694 2.37 22.43.878.324-.108 1.434-.57 1.758-.708a9.85 9.85 0 0 0 5.924-9.015c0-1.308-.262-2.631-.817-3.908-1.62-3.677-5.245-5.877-9.025-5.877a9.8 9.8 0 0 0-3.918.815"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#positive-rejseklubben_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#positive-rejseklubben_svg__b)",
    d: "M32.44 17.847H2.297v21H32.44z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "positive-rejseklubben_svg__c",
    width: 25,
    height: 37,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.934 3.63A11.6 11.6 0 0 0 1.496 7.4c-.154.385-.694 1.754-.802 2.154C.216 11.23 0 14.139 0 17.446c0 7.246.972 16.415 2.083 18.693.123.246.23.384.354.461 2.206 1.739 16.985-13.108 20.178-18.185.417-.661.771-1.415 1.08-2.415.416-1.385.632-2.77.632-4.139 0-4.784-2.591-9.107-7.343-11.03A12 12 0 0 0 13.174 0h-.617C9.317 0 6.201 1.323 3.95 3.646"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#positive-rejseklubben_svg__c)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#positive-rejseklubben_svg__d)",
    d: "M10.047-11.958-18.937 22.49l33.206 27.788L43.253 15.83z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "positive-rejseklubben_svg__f",
    width: 15,
    height: 24,
    x: 2,
    y: 5,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.538,
    cy: 11.848,
    fill: "url(#positive-rejseklubben_svg__e)",
    rx: 6.538,
    ry: 11.848,
    transform: "matrix(.95995 .28564 -.28245 .95766 6.507 3.389)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#positive-rejseklubben_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A26CAB",
    d: "M14.758 6.451C10.694 9.34 6.834 20.87 5.412 26.274l2.253 2.99 10.931-10.287z",
    opacity: 0.6
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "positive-rejseklubben_svg__h",
    width: 19,
    height: 13,
    x: 11,
    y: 22,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.541,
    cy: 28.297,
    fill: "url(#positive-rejseklubben_svg__g)",
    rx: 5.167,
    ry: 9.392,
    transform: "matrix(.4525 .84227 -.94418 .4525 37.964 -1.808)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#positive-rejseklubben_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A26DAC",
    d: "M29.306 25.86c-3.898-.78-12.667 3.248-16.564 5.36l-.487 2.922 11.935.73z",
    opacity: 0.9
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#291A4E",
    fillRule: "evenodd",
    d: "M135.935 14h-3.497v23.616h3.497zm-58.56 2.795a2.24 2.24 0 0 1 2.24-2.24c1.225 0 2.222 1.047 2.222 2.24s-.98 2.222-2.223 2.222-2.239-.98-2.239-2.222m-20.048 5.458a7.247 7.247 0 0 0-7.273-7.273H41v22.653h3.726v-8.254h4.397l4.788 8.254h4.07l-5.148-8.793c2.647-1.062 4.494-3.661 4.494-6.57zm-7.273 3.776H44.71v-7.567h5.344c1.978 0 3.563 1.65 3.563 3.791s-1.585 3.792-3.563 3.792zm17.42 8.809c-2.582 0-4.625-1.291-5.18-3.808h12.879c.065-.458.13-.965.13-1.455 0-4.658-3.301-8.548-8.123-8.548-5.082 0-8.547 3.727-8.547 8.515s3.465 8.515 8.793 8.515c3.17 0 5.59-1.324 7.076-3.53l-2.876-1.683c-.785 1.127-2.24 2.01-4.168 2.01zm-.326-10.656c2.108 0 4.135 1.193 4.625 3.971h-9.512c.49-2.419 2.272-3.971 4.887-3.971m10.724 14.072c0 2.272-.997 3.073-3.138 2.877v3.366c4.43.327 6.636-1.781 6.636-6.243V21.437h-3.498zm12.19-14.072c-1.275 0-2.37.556-2.37 1.716l.017.033c0 1.213 1.477 1.623 3.214 2.105 2.477.687 5.48 1.521 5.48 5.037 0 3.236-2.81 4.985-6.308 4.985-3.236 0-5.573-1.455-6.603-3.792l3.007-1.748c.523 1.454 1.815 2.32 3.596 2.32 1.553 0 2.746-.523 2.746-1.814 0-1.198-1.492-1.622-3.24-2.12-2.472-.702-5.455-1.551-5.455-4.94 0-3.04 2.615-4.952 5.916-4.952 2.648 0 4.854 1.226 5.982 3.366l-2.942 1.651c-.588-1.258-1.716-1.847-3.04-1.847m16.134-3.17c-5.083 0-8.548 3.726-8.548 8.515 0 4.788 3.465 8.515 8.793 8.515 3.171 0 5.59-1.324 7.093-3.53l-2.876-1.684c-.768 1.128-2.239 2.01-4.168 2.01-2.582 0-4.625-1.29-5.181-3.808h12.879c.065-.457.131-.964.131-1.454 0-4.658-3.302-8.548-8.123-8.548zm-4.919 7.158c.49-2.419 2.271-3.971 4.886-3.971 2.109 0 4.135 1.193 4.626 3.971zm25.137-6.733h4.266l-7.126 7.926 7.387 8.254h-4.184l-6.619-7.469v7.469h-3.497V14.965h3.497v13.63zm19.696 13.336c2.288 0 4.102-1.357 4.102-4.658v-8.679h3.498v16.197h-3.498v-2.076c-1.078 1.684-2.811 2.485-5.017 2.485-3.628 0-6.211-2.468-6.211-6.669v-9.937h3.498v9.578c0 2.468 1.34 3.759 3.628 3.759m20.05-13.745c-2.517 0-4.429 1.03-5.655 2.713v-8.776h-3.497v22.652h3.497v-2.32c1.226 1.715 3.138 2.745 5.655 2.745 4.397 0 8.058-3.726 8.058-8.499 0-4.772-3.661-8.515-8.058-8.515m-.539 13.68c-2.909 0-5.116-2.174-5.116-5.181s2.19-5.181 5.116-5.181 5.115 2.174 5.115 5.181-2.206 5.18-5.115 5.18m14.478-10.967c1.226-1.683 3.138-2.713 5.655-2.713 4.396 0 8.057 3.743 8.057 8.515s-3.661 8.499-8.057 8.499c-2.517 0-4.429-1.03-5.655-2.746v2.321h-3.497V14.965h3.497zm0 5.786c0 3.007 2.206 5.18 5.116 5.18s5.115-2.173 5.115-5.18-2.206-5.181-5.115-5.181-5.116 2.174-5.116 5.181m23.73-8.515c-5.083 0-8.548 3.726-8.548 8.515 0 4.788 3.465 8.515 8.793 8.515 3.171 0 5.59-1.324 7.077-3.53l-2.877-1.684c-.768 1.128-2.239 2.01-4.167 2.01-2.583 0-4.625-1.29-5.181-3.808h12.879c.065-.457.13-.964.13-1.454 0-4.658-3.301-8.548-8.122-8.548zm-4.919 7.158c.49-2.419 2.271-3.971 4.886-3.971 2.109 0 4.135 1.193 4.625 3.971zm18.861-4.674c1.079-1.683 2.811-2.484 5.017-2.484 3.629 0 6.211 2.468 6.211 6.668v9.937h-3.498V28.04c0-2.468-1.34-3.76-3.628-3.76s-4.102 1.357-4.102 4.658V37.6h-3.498V21.42h3.498z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "positive-rejseklubben_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 11.8477 -6.53841 0 6.538 11.848)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "positive-rejseklubben_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 9.39155 -5.16723 0 20.05 28.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "positive-rejseklubben_svg__b",
    x1: 3.554,
    x2: 33.682,
    y1: 29.098,
    y2: 29.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8B8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#B798C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9F66A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8B8DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "positive-rejseklubben_svg__d",
    x1: -2.869,
    x2: 21.11,
    y1: 34.816,
    y2: 6.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E65A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C8B8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8B8DB"
  })))));
};
export default SvgPositiveRejseklubben;